import { render, staticRenderFns } from "./PrivPolicyPage.vue?vue&type=template&id=269ae07b&scoped=true"
import script from "./PrivPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivPolicyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269ae07b",
  null
  
)

export default component.exports